import { Team, UserId as UserIdT } from 'api/models';
import { ProjectPermissionSetType } from 'stores/permission-sets';

type UserId = number;
type Timestamp = number;

export interface Membership {
  memberType: ProjectPermissionSetType;
  joinedAt?: Timestamp;
}

export interface Memberships {
  byUserId: {
    [userId: number]: Membership;
  };
  users: UserId[];
  placeholders?: Team[];
}

const EMPTY: Memberships = {
  byUserId: {},
  users: [],
  placeholders: [],
};

export const Memberships = {
  empty: () => EMPTY,
  set:
    (
      [, userId]: UserIdT,
      memberType: ProjectPermissionSetType,
      joinedAt?: number,
    ) =>
    ({ byUserId, users, placeholders }: Memberships): Memberships => ({
      users: users.filter((x) => x !== userId).concat(userId),
      byUserId: {
        ...byUserId,
        [userId]: { memberType, joinedAt },
      },
      placeholders,
    }),
  reset:
    ([, userId]: UserIdT) =>
    ({ byUserId, users, placeholders }: Memberships): Memberships => ({
      users: users.filter((x) => x !== userId),
      placeholders,
      byUserId: {
        ...byUserId,
        [userId]: undefined,
      } as any,
    }),
  find:
    ([, userId]: UserIdT) =>
    ({ byUserId }: Memberships): Membership | undefined =>
      byUserId[userId],
  exists:
    ([, userId]: UserIdT) =>
    ({ users }: Memberships) =>
      users.some((x) => x === userId),
};
